import {apiConstants} from "@data/constants/apiConstants";
import {authConstants} from "@data/constants/authConstants";
import {activitiesService} from "@data/services/activitiesService";
import {authService} from "@data/services/authService";
import {materialsService} from "@data/services/materialsService";

const initialState = {
    materialsList: [],
    // La confiance d'un support après une correction de son chapitre, par support : l'activité que l'écran
    // tient n'est relue qu'à la prochaine lecture de l'élève, et « Générer... » doit se débloquer aussitôt.
    chapterConfidenceById: {},
}

export default function materials(state = initialState, action) {
    switch (action.type) {
        case authConstants.LOGOUT_401:
        case authConstants.RESET_AUTH_STATE:
        case authService.logout.name + apiConstants._SUCCESS:
            return initialState
        case activitiesService.materialsSearch.name + apiConstants._SUCCESS: {
            let materialsList = []
            if (action.data?.meta?.current_page === 1) {
                materialsList = action.data?.materials
            } else {
                materialsList = state.materialsList.concat(action.data?.materials)
            }
            return {
                ...state,
                materialsList: materialsList
            }
        }
        case materialsService.updateMaterialChapter.name + apiConstants._SUCCESS: {
            const id = action.data?.id ?? action.routeParams?.id
            if (id == null) return state
            return {
                ...state,
                chapterConfidenceById: {
                    ...state.chapterConfidenceById,
                    [String(id)]: action.data?.structured_data?.analysis?.confidence ?? null,
                },
            }
        }
        default:
            return state
    }
}
